import type { PropsWithChildren } from 'react';

import { cn } from '@change/ds-utils';

import { ThemeProvider } from '@change/ds-core-ui/next';

const baseClasses = ['flex px-7 py-6 w-full'];

const unSelectedClasses = [
	'border-stroke-weaker bg-fill-inverse-strong rounded-large elevation-low border-[2px] border-solid',
	'hover:bg-fill-hover',
	'focus:border-stroke-focus',
];

const selectedClasses = ['bg-gradient-to-b from-[#F0F7FF] to-blue-100 rounded-[10px]'];

type Props = {
	className?: string;
	onClick: () => void;
	selected: boolean;
	['data-testid']?: string;
	['data-qa']?: string;
	as?: 'div' | 'button';
	error?: boolean;
};

export function Button({
	className = '',
	selected,
	onClick,
	children,
	'data-testid': dataTestId,
	'data-qa': dataQa,
	error,
	...props
}: PropsWithChildren<Props>): JSX.Element {
	const selectedStateClasses = selected ? selectedClasses.join(' ') : unSelectedClasses.join(' ');
	const containerProps = {
		'data-testid': dataTestId,
		className: `${className} ${baseClasses.join(' ')} ${selectedStateClasses} ${error ? 'border-[2px] border-solid !border-stroke-error-strong' : ''}`,
		onClick,
		'data-qa': dataQa,
	};
	const container =
		props.as === 'div' ? (
			<div {...containerProps}>{children}</div>
		) : (
			<button type="button" {...containerProps}>
				{children}
			</button>
		);

	return (
		<ThemeProvider>
			<div
				className={cn('rounded-large', { 'elevation-elevated-selected p-[2px]': selected })}
				sx={{
					background: selected ? 'linear-gradient(275deg, #0139BC 2.93%, #4BAEFF 96.39%)' : undefined,
				}}
			>
				{container}
			</div>
		</ThemeProvider>
	);
}
